import { Injectable } from '@angular/core';

import { IBitfUiRoleManagerService } from '@interfaces';
import { ERoleActions } from '@enums';
import { StoreService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class UiRoleManagerService implements IBitfUiRoleManagerService {
  constructor(private storeService: StoreService) {}

  canI(action: ERoleActions): boolean {
    switch (action) {
      case ERoleActions.VIEW_LOG:
        return true;
      case ERoleActions.IS_MEET_USER:
        return this.storeService.store.user.roles.includes('MEET');
      default:
        return false;
    }
  }
}
